import React, { useEffect } from 'react';
import { initializeAllFeatures } from '../../utils/interactiveFeatures';
import UnifiedNavigation from '../../components/Navigation/UnifiedNavigation';
import Footer from '../../components/Footer/Footer';
import InstagramSection from '../../components/BrandHomePage/InstagramSection';
import { DestinationsCarousel } from '../../components/Destinations/DestinationsCarousel/DestinationsCarousel';
import DestinationsHero from '../../components/Destinations/DestinationsHero/DestinationsHero';
import DestinationsVideo from '../../components/Destinations/DestinationsVideo/DestinationsVideo';
import DestinationsMap from '../../components/Destinations/DestinationsMap/DestinationsMap';
import DestinationsGallery from '../../components/Destinations/DestinationsGallery/DestinationsGallery';
import './DestinationsPage.css';


const DestinationsPage: React.FC = () => {
  // Initialize interactive features
  useEffect(() => {
    const cleanup = initializeAllFeatures();
    return cleanup;
  }, []);

  return (
    <div className="destinations-page" data-name="destinations" id="node-403_4539">
      {/* Navigation Header - Light variant for dark text */}
      <UnifiedNavigation 
        variant="light"
        destination={null}
      />

      {/* Page Header - 450px height */}
      <DestinationsHero />

      {/* Sticky Video Background - 840px height */}
      <DestinationsVideo />

      {/* Main Content */}
      <div className="destinations-content">
        {/* Combined Text and Map Section - includes Body Text (340px) + Map Block (960px) */}
        <DestinationsMap />

        {/* Destination Graphic Carousel - 800px height */}
        <DestinationsCarousel />

        {/* Destination Gallery - 1001px height */}
        <DestinationsGallery />
      </div>

      {/* Instagram Section - Exactly like brand homepage */}
      <InstagramSection />

      {/* Footer - Exactly like brand homepage */}
      <Footer variant="default" />
    </div>
  );
};

export default DestinationsPage;